/**
 * Where the 3-D models sit in the layer stack.
 *
 * Its own module, with no browser or MapLibre imports, so the rule can be tested directly. The order
 * used to be an EMERGENT result of a long addLayer/moveLayer sequence in map.ts with no single place
 * asserting it, which is why an interrupted setup broke it silently and only sometimes.
 */

/**
 * Flat markers that must never be painted over the 3-D models. A player's disc and sprite sit at
 * exactly the point where the character stands, so if they draw later they hide it completely — and
 * that is not reported as "the marker is on top", it is reported as "there are no player models"
 * (Cam, 2026-09-07, who said both in one message).
 *
 * Deliberately NOT the labels (`players-label`, `structures-label`, `structures-state`) or the
 * selection layers: text and the selection highlight are meant to stay legible over a model.
 */
export const FLAT_MARKERS = ["blueprints", "blueprints-icon", "structures", "structures-outline", "structures-icon",
  "loots", "radiation-icon", "players-outline", "players", "players-icon",
  "clusters-stack2", "clusters-stack1", "clusters", "cluster-count", "cl-ms", "cl-sam", "cl-sg", "cl-ore"];

/**
 * Which of those are currently ABOVE `models-gl`, i.e. hiding the models. Returned in their existing
 * relative order, so moving each to just before `models-gl` in turn puts them back underneath
 * without shuffling them against each other.
 */
export function markersOverModels(order: string[]): string[] {
  const mi = order.indexOf("models-gl");
  if (mi === -1) return [];
  return order.filter((id, i) => i > mi && FLAT_MARKERS.includes(id));
}
